module.exports = __webpack_public_path__ + "img/infra2.6b2f919e.png";